import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { canonicalLink } from 'utils/seoUtils';
import { toSlug } from 'utils';

import { localFullDateNoDay, localFullDateLong } from 'utils/LocalDateTimeHelper';

import HorseRacingFastRacecard from '../components/HorseRacingFastRacecard';

export default class HorseRacingMeetingLandingPageList extends Component {
  static propTypes = {
    routes: PropTypes.array,
    meeting: PropTypes.object,
    results: PropTypes.array
  };

  render() {
    const {
      routes,
      meeting: {
        meeting_reference: {
          id: meetingId
        },
        surface_summary: surface,
        going,
        date,
        weather,
        course: {
          name: courseName,
          course_summary: courseSummary
        } = {}
      } = {},
      results
    } = this.props;

    const helmetProps = {
      title: `${courseName} - ${localFullDateNoDay(date)}`,
      ...canonicalLink(routes, {meetingDate: date, meetingName: toSlug(courseName), meetingId})
    };

    return (
      <div className="fast-results">
        <MetaDataWrapper helmetProps={helmetProps}/>
        <div className="meeting-heading">
          <h1 className="page-title">{courseName} <small>{localFullDateLong(date)}</small></h1>
        </div>
        <div className="meeting-summary">
          <h1><small>Meeting Summary</small></h1>
          <div className="meeting-landing-page-summary-going">
            Going: {going}
          </div>
          <div className="meeting-landing-page-summary-surface">
            Surface: {surface}
          </div>
          <div className="meeting-landing-page-summary-weather">
            Weather: {weather}
          </div>
        </div>
        {(results && (results.length > 0)) ?
          <div className="fast-results-list">
            {results.map(race => (
              (race.race_reference == null || race.race_reference == undefined) ?
                <div className="fast-racecard-item">Fast Result not available.</div> :
                <HorseRacingFastRacecard key={race.race_reference.id} {...race} meetingMode/>
            ))}
          </div>
        :
          <div className="no-fast-results">No fast results.</div>
        }
        {courseSummary && <div className="course-summary">
          <h1><small>Course Summary</small></h1>
          {courseSummary.split("\n").map((p, i) => <p key={i}>{p}</p>)}
        </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingMeetingLandingPageList.js